import { View } from 'react-native'
import { Modal, Portal } from 'react-native-paper'

import UniButton from '@/components/unistyles/UniButton'
import UniText from '@/components/unistyles/UniText'
import useModalStyles from '@/hooks/useModalStyles'

interface ScanRequestModalProps {
  visible: boolean
  fosterName: string
  onConfirm: () => void
  onDismiss: () => void
  isPending?: boolean
}

const ScanRequestModal = ({
  visible,
  fosterName,
  onConfirm,
  onDismiss,
  isPending = false,
}: ScanRequestModalProps) => {
  const { styles } = useModalStyles()

  return (
    <Portal>
      <Modal
        onDismiss={onDismiss}
        style={styles.modal}
        testID="scan-request-modal"
        visible={visible}
      >
        <View style={styles.card}>
          <UniText style={styles.title} variant="titleLarge">
            Scan from your phone
          </UniText>
          <UniText style={styles.body} variant="bodyMedium">
            We&apos;ll send a push notification to your phone. When you tap it,
            the document scanner will open so you can scan and upload documents
            directly to {fosterName}.
          </UniText>
          <UniButton
            contentStyle={styles.buttonContent}
            disabled={isPending}
            mode="contained"
            onPress={onConfirm}
            style={styles.primaryButton}
            testID="scan-request-modal-confirm-button"
          >
            Send to Phone
          </UniButton>
          <UniButton
            contentStyle={styles.buttonContent}
            disabled={isPending}
            mode="text"
            onPress={onDismiss}
            style={styles.textButton}
            testID="scan-request-modal-cancel-button"
          >
            Cancel
          </UniButton>
        </View>
      </Modal>
    </Portal>
  )
}

export default ScanRequestModal
